import React, { useState, useEffect } from 'react'

import { updateEvent, getEvent, deleteEvent } from '../Context/firebase'
import { useAuth } from '../Context/Auth'
import { getActivity } from '../Context/prismic'
import { useParams } from 'react-router-dom'

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import ActivityPickerModal from '../Components/ActivityPickerModal'
import ActivityPreview from '../Components/ActivityPreview'
import dateFns from 'date-fns'
import moment from 'moment'

// Components and styles
import {
  FlexboxGrid, IconButton, Loader, DatePicker, Timeline, Form, FormControl,
  Divider, ButtonToolbar, Icon, FormGroup, Checkbox, CheckboxGroup, SelectPicker,
  Drawer
} from 'rsuite'

import { EmptyTimeline, Summary, EmptyPhaseModal, DeleteModal, PhaseSummary, ActivityCard } from '../Components/MyEvent/EventComponents'
import { colors, fonts } from '../Components/Styles/common-styles'
import {
  H1, Title, FlexWrapper, InlineFlex,
  AddActivity, SmallTitle, Back, Button, StartButton
} from '../Components/MyEvent/MyEventStyledComponents'
import { PaginateFilter, Bin } from '../Components/Icons'
import '../Components/Styles/event.css'
import '../Components/Styles/activities.css'

import _ from 'lodash'
import { v4 } from 'uuid'
import styled from 'styled-components'

const MyDrawer = styled(Drawer)`
-webkit-animation: slide-in 0.7s forwards;
.rs-drawer-content {
  overflow: auto;
},
`

const Styles = {
  toolBar: {
    display: 'inline-flex',
    lineHeight: 1.42857143
  }
}

const goalsMockup = [
  {
    title: 'conduct good teamwork and...',
    goals: ['work actively together',
      'build a confidential working atmosphere',
      'come up with something new together',
      'involve all participants in the work as equally as possible',
      'make hidden knowledge in the work community visible for shared use at the team and organisational level'
    ]
  },
  {
    title: 'develop a clear plan and...',
    goals: ['agree how we will proceed in the future',
      'agree on how to monitor progress',
      'clarify the goals of the event as well as the common ways in which they will be achieved',
      'prioritize and selecting the ideas to be developed'
    ]
  },
  {
    title: 'learn the subject and...',
    goals: ['receive new information and learn about new subject',
      'look at the theme from new perspectives and challenge our thinking',
      'refine the subject forward'
    ]
  },
  {
    title: 'evaluate success and...',
    goals: ['decide how to gather feedback and evaluate success']
  }
]

const EditEvent = () => {
  const { currentUser } = useAuth()
  const { eventId } = useParams()
  const [isSaved, setSaved] = useState(false)
  const [isActivityPickerVisible, setActivityPickerVisible] = useState(false)
  const [showModal, setModalShown] = useState(false)
  const [showPhaseModal, setPhaseModal] = useState(false)
  const [showActivityPreviewModal, setActivityPreviewModal] = useState(false)
  const [activityId, setActivityId] = useState(null)
  const [timeArray, setTimeArray] = useState([])
  const [defaultTime, setDefaultTime] = useState('')
  const [goalsArray, setGoals] = useState([])
  const [error, setError] = useState('')
  const [selectedPhaseIndex, setSelectedPhaseIndex] = useState(null)
  const [updated, setUpdated] = useState(false)
  const [event, setEvent] = useState({
    id: v4(),
    title: '',
    date: '',
    phases: null,
    author: currentUser.uid
  })
  const template = {
    goals: [],
    phases: [
      { name: 'Warm up', data: [] },
      { name: 'Work', data: [] },
      { name: 'Wrap up', data: [] }
    ]
  }
  // Function to retrieve event details
  useEffect(() => {
    getEvent(eventId).then(data => {
      setEvent(data)
      setDefaultTime(moment(data.date).format('HH:mm'))
      setGoals(data.goalsArray)
    }).catch(err => {
      setError('Event not found')
      console.log(err)
    })
  }, [])

  useEffect(() => {
    if (event) {
      setEvent({ ...event })
    }
    return setUpdated(false)
  }, [updated])

  // Function to generate time values
  useEffect(() => {
    let i; let j
    for (i = 0; i < 24; i++) {
      for (j = 0; j < 4; j++) {
        timeArray.push({
          label: (i < 10 ? '0' + i : i) + ':' + (j === 0 ? '00' : 15 * j),
          value: (i < 10 ? '0' + i : i) + ':' + (j === 0 ? '00' : 15 * j)
        })
      }
    }

    setTimeArray([...timeArray])
  }, [])

  // Function to select and save activities from activities library
  async function onSelectActivity (id) {
    const activity = await getActivity(id)
    activity.id = v4()
    event.phases[selectedPhaseIndex].data.push({ ...activity })
    setEvent({ ...event })
    setUpdated(true)
  }

  // Function to handle changes in text fields
  const handleChange = (name, data) => {
    event[name] = data
    setEvent({ ...event })
    setSaved(false)
  }

  const handleDateChange = (name, date) => {
    const newDate = new Date(event.date)
    if (date !== null) {
      if (name !== 'time') {
        newDate.setDate(date.getDate())
        newDate.setMonth(date.getMonth())
        newDate.setYear(date.getYear() + 1900) // why? https://developer.mozilla.org/ru/docs/Web/JavaScript/Reference/Global_Objects/Date/getYear
        setEvent({ ...event, date: +newDate })
      } else {
        newDate.setHours(date.split(':')[0])
        newDate.setMinutes(date.split(':')[1])
        setEvent({ ...event, date: +newDate })
        setDefaultTime(date)
      }
    }
    setSaved(false)
  }

  // Function to handle changes in phase
  const handlePhaseChange = (index, name, data) => {
    event.phases[index].name = data
    setEvent({ ...event })
    setSaved(false)
  }
  // new phase handler
  const addPhase = () => {
    event.phases.push({ name: '', data: [] })
    setEvent({ ...event })
    setPhaseModal(false)
  }

  // Function to delete a phase
  const handlePhaseDelete = (props) => {
    event.phases.splice(selectedPhaseIndex, 1)
    setEvent({ ...event })
    if (!event.phases.length) {
      setPhaseModal(true)
    }
    setModalShown(false)
  }

  // Function to delete a single activity
  const handleActivityDelete = (props) => {
    const id = props.currentTarget.value
    const index = props.currentTarget.getAttribute('index')
    event.phases[index].data.splice(_.indexOf(event.phases[index].data, id), 1)
    setEvent({ ...event })
    props.stopPropagation()
  }

  // Function to Save event details to database
  async function handleSave () {
    try {
      console.log('try to save', event)
      await updateEvent(event.id, {
        ...event,
        goalsArray
      })
      setTimeout(() => {
        window.location.href = `/events/${eventId}/event`
      }, 2000)
    } catch (error) {
      console.error(error)
      setSaved(false)
      return setError('Unable to save event')
    }
    setSaved(true)
    setError('')
  }
  // Function to delete event permanently
  async function handleDelete (props) {
    try {
      console.log('try to delete' + eventId)
      await deleteEvent(eventId)
      setModalShown(false)
      window.location.href = '/events/'
    } catch (error) {
      console.error(error)
      return setError('Unable to Delete')
    }
    setError('')
  }
  // const handlePhaseDrag = (result) => {
  //   const items = Array.from(event.phases)
  //   const [reorderedItem] = items.splice(result.source.index, 1)
  //   items.splice(result.destination.index, 0, reorderedItem)
  //   event.phases = items
  //   setEvent({ ...event })
  // }

  const handleActivityDrag = (result) => {
    if (!result.destination) return
    if (result.source.droppableId !== result.destination.droppableId) {
      const sourcePhase = Array.from(event.phases[result.source.droppableId].data)
      const [removed] = sourcePhase.splice(result.source.index, 1)
      event.phases[result.source.droppableId].data = [...event.phases[result.source.droppableId].data, { data: sourcePhase }]

      const destinationPhase = Array.from(event.phases[result.destination.droppableId].data)
      destinationPhase.splice(result.destination.index, 0, removed)
      event.phases[result.destination.droppableId].data = [...destinationPhase]

      setEvent({ ...event })
      console.log(event.phases[result.source.droppableId].data = Array.from(sourcePhase))
      return
    }

    const items = Array.from(event.phases[result.source.droppableId].data)
    const [reorderedItem] = items.splice(result.source.index, 1)
    items.splice(result.destination.index, 0, reorderedItem)
    event.phases[result.source.droppableId].data = [...items]
    setEvent({ ...event })
  }
  // Function to handle changes in goals
  const handleGoalSelect = (title, goal, selected, index) => {
    if (selected) {
      goalsArray.push({ title: title, goals: goal })
      if (goalsArray.length === 1) {
        template.phases.map(phase => event.phases.push(phase))
      }
    } else {
      _.remove(goalsArray, g => g.goals === goal)
      if (!goalsArray.length) {
        event.phases = []
      }
    }
    setGoals([...goalsArray]) // for force rerendering
    setSaved(false)
  }
  const getGoals = () => goalsArray ? goalsArray.map(i => i.goals) : event.goals
  const editActivity = (id, phase) => {
    if (id) {
      const index = event.phases[phase].data.findIndex(activity => activity.id === id)
      const data = event.phases[phase].data[index]
      return { data, index }
    }
  }
  // Edit Event component
  return (
    <FlexboxGrid justify='center' style={{ margin: '26px 20px 20px 28px' }}>
      <ActivityPickerModal
        isActivityPickerVisible={isActivityPickerVisible}
        setActivityPickerVisible={setActivityPickerVisible}
        onSelectActivity={onSelectActivity}
        goals={getGoals()}
      />

      <MyDrawer
        full
        show={showActivityPreviewModal}
        onHide={() => setActivityPreviewModal(false)}
      >
        <ActivityPreview
          setActivityPreviewModal={setActivityPreviewModal}
          // activityId={showActivityPreviewModal}
          event={event}
          setEvent={setEvent}
          phaseIndex={selectedPhaseIndex}
          data={editActivity(activityId, selectedPhaseIndex)}
        />
      </MyDrawer>

      <DeleteModal
        show={showModal}
        handleClose={() => setModalShown(false)}
        setSelectedPhaseIndex={setSelectedPhaseIndex}
        onDelete={(selectedPhaseIndex) => handlePhaseDelete}
        title={!event.phases ? null : !event.phases.length ? null : event?.phases[selectedPhaseIndex]?.name || 'unnamed phase'}
        msg='Phase'
      />
      <EmptyPhaseModal
        show={showPhaseModal}
        handleClose={setModalShown}
        addPhase={addPhase}
        onDelete={handleDelete}
      />
      <Form>
        <FlexboxGrid.Item colspan={24}>
          {
            error && <div>{error}</div>
          }
          <H1 style={{ marginBottom: '2%' }}>Edit event</H1>
          <InlineFlex style={{ width: '100%', height: '100%' }}>
            <FormGroup colSpan={20}>
              <FormControl
                type='text'
                onChange={(e) => handleChange('title', e)}
                defaultValue={event.title}
                value={event.title}
                style={{ width: '400px', height: '100%', margin: '1%' }}
              />
            </FormGroup>
            <FormGroup>
              <ButtonToolbar style={Styles.toolBar} colSpan={4}>
                <Button bordered onClick={e => { window.location.href = `/events/${eventId}/event` }}>Cancel</Button>
                {!isSaved
                  ? <StartButton onClick={() => handleSave()}>
                    Save
                  </StartButton>
                  : <Button saved>Saved !</Button>}
              </ButtonToolbar>
            </FormGroup>
          </InlineFlex>
        </FlexboxGrid.Item>
        <InlineFlex className='scroll'>
          <FlexboxGrid.Item colspan={8}>
            <InlineFlex style={{ margin: '1% 1% 2% 1%', width: '380px' }}>
              <FlexWrapper>
                <p>Date *</p>
                <DatePicker
                  defaultValue={new Date(event.date)}
                  value={new Date(event.date)}
                  onChange={value => handleDateChange('date', value)}
                  style={{ width: '180px' }}
                  disabledDate={date => dateFns.isBefore(date, new Date())}
                  cleanable={false}
                  oneTap
                  isoWeek
                />
              </FlexWrapper>
              <FlexWrapper style={{ marginLeft: '10%' }}>
                <p>Starts at *</p>
                <SelectPicker
                  data={timeArray}
                  value={defaultTime}
                  cleanable={false}
                  onChange={(date) => handleDateChange('time', date)}
                  searchable={false}
                  style={{ width: 150, textAlign: 'center' }}
                  className='rs-picker-date-only-time'
                />
              </FlexWrapper>
            </InlineFlex>
            {!event.phases ? <Loader /> : <Summary {...event} />}
            <Divider />
            <FlexWrapper>
              <H1>Goals</H1>
              <Title>I want to....</Title>
              {!goalsArray
                ? null
                : goalsMockup.map((block, index) =>
                  <GoalsBlock
                    handleGoalSelect={handleGoalSelect}
                    key={index}
                    goals={block.goals}
                    title={block.title}
                    checkedgoals={goalsArray}
                  />
                )}
            </FlexWrapper>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={16}>
            <DragDropContext onDragEnd={handleActivityDrag}>

              <Timeline className='customTimeline' endless>
                <FlexWrapper>
                  {!event.phases
                    ? <AddActivity
                      onClick={() => setActivityPickerVisible(true)}
                      setSelectedPhaseIndex={setSelectedPhaseIndex}
                    />
                    : event.phases
                      ? <PhasesConstructor
                        phases={event.phases}
                        onClickAdd={() => setActivityPickerVisible(true)}
                        setSelectedPhaseIndex={setSelectedPhaseIndex}
                        handleChange={handlePhaseChange}
                        handleDelete={handleActivityDelete}
                        showDeleteModal={setModalShown}
                        setActivityId={setActivityId}
                        setActivityPreviewModal={setActivityPreviewModal}
                        addPhase={addPhase}
                      />
                      : <EmptyTimeline />}
                </FlexWrapper>
              </Timeline>

            </DragDropContext>
          </FlexboxGrid.Item>
        </InlineFlex>
      </Form>
    </FlexboxGrid>
  )
}

// Goals block component
const GoalsBlock = ({ title, goals, handleGoalSelect, checkedgoals }) => {
  const handleChecked = (goal) => {
    return checkedgoals.some(i => i.goals.includes(goal))
  }
  return (
    <>
      <Title>{title}</Title>
      <CheckboxGroup>
        {goals.map((goal, index) =>
          <Checkbox
            checked={handleChecked(goal)}
            onChange={(value, checked) => handleGoalSelect(title, goal, checked, index)}
            key={index}>
            {goal}
          </Checkbox>
        )}
      </CheckboxGroup>
    </>
  )
}
// Phases block Component
const PhasesConstructor = ({
  phases = [], onClickAdd, setSelectedPhaseIndex, setActivityId,
  handleChange, handleDelete, addPhase, showDeleteModal,
  setActivityPreviewModal
}) => {
  return (
    <>
      {
        phases.map((phase, index) =>
          <Timeline.Item key={index} dot={<Icon className='customDot' icon='' />}>
            <InlineFlex>
              <div style={{ display: 'inline-flex' }}>
                <SmallTitle style={{ width: '100px' }} bolded>Phase {index + 1}: </SmallTitle>
                <FormControl
                  style={{ border: 'none', background: 'transparent', fontSize: `${fonts.bigSize}` }}
                  defaultValue={phase.name}
                  value={phase.name}
                  onChange={(e) => handleChange(index, 'name', e)}
                  name='phase name' />
              </div>
              <div style={{ display: 'inline-flex' }}>
                <PhaseSummary {...phase} />
                <IconButton
                  style={{ alignSelf: 'flex-end' }}
                  className='i-button'
                  onClick={() => {
                    setSelectedPhaseIndex(index)
                    showDeleteModal(true)
                  }}
                  icon={<Bin stroke={colors.grey} />} />
              </div>
            </InlineFlex>
            <Droppable droppableId={index.toString()} key={index} direction='horizontal'>
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <FlexWrapper>
                    <InlineFlex style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                      {!phase
                        ? <Loader />
                        : phase.data.map((item, i) => {
                          return (
                            <Draggable key={item.id} draggableId={item.id} index={i}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}>
                                  <ActivityCard
                                    previewOnClick={() => {
                                      setActivityPreviewModal(true)
                                      setSelectedPhaseIndex(index)
                                    }}
                                    key={i}
                                    setActivityId={setActivityId}
                                    data={item}
                                    setSelectedPhaseIndex={setSelectedPhaseIndex}
                                    handleDelete={handleDelete}
                                    index={index}
                                    activityindex={i}
                                  />
                                </div>
                              )}
                            </Draggable>
                          )
                        })}
                      <AddEventActivity
                        onClick={() => {
                          setSelectedPhaseIndex(index)
                          onClickAdd()
                        }}
                      />
                      {provided.placeholder}

                    </InlineFlex>
                  </FlexWrapper>
                </div>
              )}
            </Droppable>
          </Timeline.Item>

        )
      }
      <Timeline.Item dot={<Icon className='customDot' icon='' />}>
        <div> <Back onClick={addPhase} colored padded> &#x2B; create new phase</Back> </div>
      </Timeline.Item>
    </>
  )
}

// Component for a new Activity
const AddEventActivity = ({ onClick }) =>
  <AddActivity onClick={onClick}>
    <FlexWrapper style={{ alignItems: 'center', marginTop: '35%' }}>
      <IconButton className='btn-bounce' icon={<PaginateFilter />} />
      <Title style={{ color: `${colors.purpleMain}`, margin: '3% auto' }}>Add Activity</Title>
    </FlexWrapper>
  </AddActivity>

export default EditEvent
